import { AxiosResponse } from "axios";
import fileSaver from "file-saver";

/**
 * 將 API 回傳的檔案內容觸發瀏覽器下載
 * @param response - 呼叫 API 時 responseType 需先設為 blob（`responseType: "blob"`）
 * @param fileName - 下載檔名，未傳時改由後端 Content-Disposition 的 `filename*=utf-8''` 解析（支援中文）
 */
export default function downloadFileFromResponse(response: AxiosResponse<Blob>, fileName?: string) {
  const resolvedFileName =
    fileName ?? decodeURIComponent(response.headers["content-disposition"].replace("attachment; filename*=utf-8''", ""));
  fileSaver.saveAs(response.data, resolvedFileName);
}
